import { useMemo } from 'react';

import { useExpandingButtonContext } from './context';

const ExpandingButtonContent: React.FunctionComponent = function () {
  const {
    button,
    buttonId,
    content,
    collapseRef,
    contentStyle,
    direction,
    onClick,
  } = useExpandingButtonContext();

  const mainClassName = useMemo(
    () =>
      ['flex', direction === 'down' ? 'flex-col' : 'flex-col-reverse'].join(
        ' ',
      ),
    [direction],
  );

  return (
    <div className={mainClassName}>
      <button type="button" id={buttonId} onClick={onClick}>
        {button}
      </button>
      <div className="overflow-hidden" style={contentStyle}>
        <div ref={collapseRef}>{content}</div>
      </div>
    </div>
  );
};

export default ExpandingButtonContent;
